export default __webpack_public_path__ + "static/media/icon-phone-verified-like.6db1ba1d.svg";